import React, { Component } from 'react'
import styled from 'styled-components'
import Question from 'svg/Question'
import theme from '../../themes/light'

const Wrapper = styled.div`
  color: white;
  background-color: ${theme.labelColor};
  text-align: center;
  border-radius: 9999px;
  flex: 0 0 auto;
  display: flex;
  padding: .25rem;

  svg {
    fill: white;
    margin: auto;
  }
`

class Unknown extends Component {
  render () {
    return (
      <Wrapper>
        <Question width={6} height={6} />
      </Wrapper>
    )
  }
}

export default Unknown
